<template>
  <v-app>
    <router-view />
    <loader-view />
    <notification />
  </v-app>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { onMessage } from 'firebase/messaging'
import LoaderView from '@/components/generals/Loader'
import Notification from '@/components/generals/Notification'

export default {
  name: 'App',
  components: {
    LoaderView,
    Notification
  },
  computed: {
    ...mapState(['loading', 'firebaseMessagingInstance'])
  },
  async mounted() {
    await this.initializeFirebaseMessaging()
    if (this.firebaseMessagingInstance) {
      onMessage(this.firebaseMessagingInstance, (payload) => {
        this.showNotification({
          title: payload.notification.title,
          text: payload.notification.body
        })
      })
    }
  },
  methods: {
    ...mapMutations(['showNotification']),
    ...mapActions(['initializeFirebaseMessaging'])
  }
}
</script>

<style scoped>
.v-application {
  background: var(--v-primary-base) !important;
}
</style>
